import { Typography } from '@mui/material'
import { BerthPlanningViewStore } from '@planning/pages/BerthPlanning/Stores/BerthPlanningViewStore'
import { VesselVisitBerthAndTimingFormStore } from '@planning/pages/VesselVisit/Stores/VesselVisitBerthAndTimingFormStore'
import { useTranslate } from '@tolgee/react'
import { DataControlCard, DataControlCardProps, RequiredField, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { VesselVisitBerthAndTimingSubForm } from './VesselVisitBerthAndTimingSubForm'
import { VesselVisitBerthAndTimingViewMode } from './VesselVisitBerthAndTimingViewMode'

type VesselVisitBerthAndTimingControlCardProps = {
  vesselVisitBerthAndTimingFormStore: VesselVisitBerthAndTimingFormStore
  berthPlanningViewStore: BerthPlanningViewStore
  isEditMode: boolean
} & Partial<DataControlCardProps>

export const VesselVisitBerthAndTimingControlCard: FC<VesselVisitBerthAndTimingControlCardProps> =
  observer(props => {
    const { vesselVisitBerthAndTimingFormStore, berthPlanningViewStore, isEditMode } = props
    const { t } = useTranslate()
    const theme = useMinimalsTheme()

    return (
      <DataControlCard
        {...props}
        title={
          <>
            {t('berthAndTimings', 'Berth & timings')} <RequiredField />
          </>
        }
        autoFocusId='eta'
        dataCy='berth-and-timings'
        viewComponent={
          vesselVisitBerthAndTimingFormStore ? (
            <VesselVisitBerthAndTimingViewMode store={vesselVisitBerthAndTimingFormStore} />
          ) : (
            <Typography variant='body2' color={theme.palette.text.secondary}>
              {t('noInformationYet', 'No information yet')}
            </Typography>
          )
        }
        editComponent={
          vesselVisitBerthAndTimingFormStore && (
            <VesselVisitBerthAndTimingSubForm
              store={vesselVisitBerthAndTimingFormStore}
              berthPlanningViewStore={berthPlanningViewStore}
              hideTypeSelector={isEditMode}
            />
          )
        }
        // isEditMode here referes to the edit mode of the page, not the card
        defaultEditMode={!isEditMode}
      />
    )
  })
